import { Component, EventEmitter, Injector, OnDestroy, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { ActivationCodeModel } from '../../models/activation-code.model';
import { RegistrationService } from '../../services/registration.service';
import AudioHelper from '../../../audio/helpers/audio.helper';

@Component({
  selector: 'activation-code',
  templateUrl: './activation-code.component.html',
})
export class ActivationCodeComponent implements OnDestroy {

  @Output() public canceled: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  public activationCode: ActivationCodeModel = new ActivationCodeModel();
  public error: { message: { title: string, text: string } } = {message: {title: null, text: null}};

  protected audioHelper: AudioHelper;

  private activationSubscription: Subscription = null;

  /**
   * Constructor
   *
   * @param {RegistrationService} registrationService
   * @param {Router} router
   * @param injector
   */
  public constructor(
    private registrationService: RegistrationService,
    private router: Router,
    private injector: Injector,
  ) {
    this.audioHelper = injector.get(AudioHelper);
  }

  /**
   * Submit the activationCode
   *
   * @return void
   */
  public onSubmit(): void {
    this.activationSubscription = this.registrationService.sendActivationCode(this.activationCode)
      .subscribe({
        next: () => {
          return this.router.navigate(['registration', this.activationCode.code]);
        },
        error: (errorResponse) => {
          this.audioHelper.playAudio('error');
          this.error = errorResponse.error;
        },
      });
  }

  /**
   * When the user canceled the activation code form
   *
   * @return void
   */
  public onCancel(): void {
    this.canceled.emit(true);
  }

  /**
   * When the Component is destroyed unsubscribe activationSubscription
   *
   * @return void
   */
  public ngOnDestroy(): void {
    if (this.activationSubscription) {
      this.activationSubscription.unsubscribe();
    }
  }
}
